import * as React from 'react'
import { Modal, ModalBody, ModalFooter } from 'uiComponents/popups/modal.new'
import { ActionButton } from 'uiComponents/buttons'
import './leaveDialog.scss'
import { useTranslation } from 'translations'

interface LeaveDialogProps {
    onStay: () => void
    onLeave: () => void
}

export function LeaveDialog({ onStay, onLeave }: LeaveDialogProps) {
    const { t } = useTranslation()
    React.useEffect(() => {
        const onKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onStay()
            }
        }
        document.addEventListener('keydown', onKeyDown)
        return () => document.removeEventListener('keydown', onKeyDown)
    }, [onStay])

    return (
        <Modal title={t('capacity.save.unsaved.title')} onDismiss={onStay} className="capacity-leave-dialog">
            <ModalBody>
                <p className="capacity-leave-text">{t('capacity.save.unsaved.text')}</p>
            </ModalBody>
            <ModalFooter>
                <div className="capacity-leave-actions">
                    <ActionButton type="button" size="large" secondary onClick={onStay} autoFocus>
                        {t('capacity.save.unsaved.stay')}
                    </ActionButton>
                    <ActionButton type="button" size="large" onClick={onLeave}>
                        {t('capacity.save.unsaved.leave')}
                    </ActionButton>
                </div>
            </ModalFooter>
        </Modal>
    )
}
